/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

exports.__esModule = true;
/**
 * @file to-title-case.js
 *
 * Uppercase the first letter of a string
 *
 * @param  {String} string String to be uppercased
 * @return {String}
 * @private
 * @method toTitleCase
 */
function toTitleCase(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

exports["default"] = toTitleCase;




//////////////////
// WEBPACK FOOTER
// ./node_modules/video.js/es5/utils/to-title-case.js
// module id = 126
// module chunks = 0